var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52876 5.52864C3.78911 5.26829 4.21122 5.26829 4.47157 5.52864L8.00016 9.05723L11.5288 5.52864C11.7891 5.26829 12.2112 5.26829 12.4716 5.52864C12.7319 5.78899 12.7319 6.2111 12.4716 6.47145L8.47157 10.4714C8.21122 10.7318 7.78911 10.7318 7.52876 10.4714L3.52876 6.47145C3.26841 6.2111 3.26841 5.78899 3.52876 5.52864Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCollapseIcon);
export default __webpack_public_path__ + "static/media/list-collapse-icon.4394e4bcee73cae2b91b2cd658f0d910.svg";
export { ForwardRef as ReactComponent };